import MuiLinearProgress, {
  LinearProgressProps
} from '@mui/material/LinearProgress';

export interface ILinearProgressProps extends LinearProgressProps {}

const LinearProgress = (props: ILinearProgressProps): JSX.Element => {
  return <MuiLinearProgress {...props} />;
};

export default LinearProgress;
